var map = {
	"./img_1.jpg": 51800,
	"./img_2.jpg": 55812,
	"./img_3.jpg": 65226,
	"./img_4.png": 51439,
	"./img_5.jpg": 94586,
	"./img_6.jpg": 67478
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26427;